import React, { useState, useRef, useEffect } from 'react';
import AdminAPI from "./AdminAPI.js";
import { Modal, Button } from "react-bootstrap";
import LoadingDiv from "./LoadingDiv";

const adminapi = new AdminAPI();

const TermsGuard = ({ children }) => {
    const [needsAck, setNeedsAck] = useState(false);
    const [loading, setLoading] = useState(true);
    const [termsAndConditions, setTermsAndConditions] = useState("");
    const [error, setError] = useState(null);
    const scrollContainerRef = useRef(null);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    
    const handleScroll = (e) => {
	const target = e.target;
	
	// Calculate if the user has reached the bottom of the terms
	const isAtBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 5;
	
	if (isAtBottom) {
	    setButtonDisabled(false);
	}
    };


    const logoutUser = async () => {
        await adminapi.logoutUser().then((response) => {
            window.location.reload();
        });

    }
        
    const checkTermsStatus = async () => {
	await adminapi.checkTermsStatus().then((response) => {
	    console.log(response);
	    if (response.enabled == false) {
		sessionStorage.setItem('terms_acknowledged', 'true');
		setNeedsAck(false);
	    }
	    else if (response.enabled && response.has_accepted) {
		sessionStorage.setItem('terms_acknowledged', 'true');
		setNeedsAck(false);
	    } else {
		setNeedsAck(true);
		setTermsAndConditions(response.terms);
	    }
	}).catch(err => {
	    console.log(err);
	    console.error("Failed to verify terms compliance", err);
	}).finally(() => {
	    setLoading(false);
	});
    }

    
    useEffect(() => {
	// 1. Check the Session Cache first
	const cachedTermsStatus = sessionStorage.getItem('terms_acknowledged');
	
	if (cachedTermsStatus === 'true') {
	    setNeedsAck(false);
	    setLoading(false);
	    return;
	}

	checkTermsStatus();
      
    }, []);


    const rejectAndLogout = async () => {
        // Accept terms                                                                                                                           
        await adminapi.rejectTerms().then((response) => {
	    logoutUser();
        }).catch(err => {
            console.log(err);
            alert("Error saving your acknowledgment. Please try again.");
        });
    }
    
    
    const handleAcceptTerms = async () => {
	// Accept terms
	await adminapi.acceptTerms().then((response) => {
	    sessionStorage.setItem('terms_acknowledged', 'true');
	    setNeedsAck(false);
	}).catch(err => {
	    console.log(err);
	    alert("Error saving your acknowledgment. Please try again.");
	});
    }
    
    if (loading) {
	return <LoadingDiv></LoadingDiv>
    }
    
    return (
	<>
	    {/* Render the core application regardless */}
	    {children}
	    
	    <Modal show={needsAck} onHide={handleAcceptTerms} backdrop="static" centered>
		<Modal.Header>
                    <Modal.Title>Terms and Conditions Update</Modal.Title>
		</Modal.Header>
		<Modal.Body>
                    <p className="lead fw-bold">
		    Please review and accept our updated terms and conditions to continue using VINCE-NT.</p>
		    <div className="vincent_tandc" ref={scrollContainerRef} onScroll={handleScroll}>
			<div className="tandchtml" dangerouslySetInnerHTML={{__html: termsAndConditions}}></div>
		    </div>
            </Modal.Body>
            <Modal.Footer className="d-flex gap-2 align-items-start">
		<Button variant="secondary" onClick={rejectAndLogout} disabled={buttonDisabled}>
		    Reject and Logout
		</Button>
		<Button variant="primary" onClick={handleAcceptTerms} disabled={buttonDisabled}>
		    I Accept
		</Button>
            </Modal.Footer>
	</Modal>
	
	</>
    )
}

export default TermsGuard;
